/* eslint-disable */
import { MenuItem, Select } from "@mui/material";

const CustomReportSelect = ({name, id, list, onChange, ...restProps}) => {

    return (
        <Select
            {...restProps}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            onChange={onChange}
        >
            <MenuItem 
            disabled
            sx={{display : 'none'}}
            key="empty"
            value={''}>
                <em>None</em>
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.code} value={opt.code+','+opt.title}>
                {opt.title}
            </MenuItem> 
            ))}
        </Select>
    );
};

export default CustomReportSelect;